import usersService from '../services/users'
import { SET_USER, CLEAR_USER, UPDATE_USER } from '../actions/auth'
import { notification } from 'antd'

import { message } from 'antd'
import subscribeUser from './../subscription'

// manpulates the data coming from backend
const adapterFunc = (user) => {
  return { ...user.user, token: user.token }
}

let user = window.localStorage.getItem('WiseAcademy-user')
const intialState = user
  ? { user: adapterFunc(JSON.parse(user)), isAuth: true }
  : { user: null, isAuth: false }

const authReducer = (state = intialState, action) => {
  switch (action.type) {
    case SET_USER:
      return { user: adapterFunc(action.user), isAuth: true }
    case UPDATE_USER:
      return { user: adapterFunc(action.user), isAuth: true }
    case CLEAR_USER:
      return { user: null, isAuth: false }
    default:
      return state
  }
}

export const editProfile = (user) => {
  return async (dispatch) => {
    try {
      const response = await usersService.update(user)
      console.log(response)
      if (response) {
        window.localStorage.setItem('WiseAcademy-user', JSON.stringify(response))
        dispatch({ type: UPDATE_USER, user: response })
        notification.success({
          message: 'Saved Successfully'
        })
      } else {
        notification.error({
          message: 'Cant Save'
        })
      }
    } catch (error) {
      notification.error({
        message: 'Cant Save'
      })
      console.log(error)
    }
  }
}

export const register = (credentials) => {
  return async () => {
    try {
      const response = await usersService.register(credentials)
      if (!response) {
        throw new Error('invalid error with response')
      }
      return response
    } catch (error) {
      // backend sends mongoose validation errors as JSON; surface something useful
      const backendMsg =
        error?.response?.data?.message ||
        (typeof error?.response?.data === 'string' ? error.response.data : null)

      // If mongoose validation errors exist, show the first one
      const firstValidationError =
        error?.response?.data?.errors &&
        Object.values(error.response.data.errors)[0]?.message

      message.error(firstValidationError || backendMsg || 'Registration failed')
      console.log('[register] failed', error?.response?.data || error)
      throw error
    }
  }
}

/* actions for authentication bellow */

export const login = (credentials) => {
  return async (dispatch) => {
    try {
      const response = await usersService.login(credentials)
      window.localStorage.setItem('WiseAcademy-user', JSON.stringify(response))
      subscribeUser();
      dispatch({ type: SET_USER, user: response })
      console.log('subscribed')
    } catch (error) {
      console.log(error)
      // the backend should send the error message to show
      // message.error(error.response.data.message)
      message.error('invalid credentials')
    }
  }
}

export const logout = () => {
  return async (dispatch) => {
    // Always clear client-side auth state, even if server logout fails.
    // This prevents "Sign out" appearing to do nothing on protected routes.
    dispatch({ type: CLEAR_USER })
    window.localStorage.removeItem('WiseAcademy-user')

    try {
      await usersService.logout()
    } catch (error) {
      // Server may reject if token already expired/invalidated; client is already signed out.
      console.log(error)
    }
  }
}

export const updateNewsletterPreference = (subscribed) => {
  return async (dispatch) => {
    try {
      const response = await usersService.setNewsletterPreference(subscribed)
      // keep auth state + localStorage in sync
      window.localStorage.setItem('WiseAcademy-user', JSON.stringify(response))
      dispatch({ type: UPDATE_USER, user: response })
    } catch (error) {
      console.log(error)
    }
  }
}

/**
 * NEW: Initialize auth from side-effects (cookies)
 * Useful for restoring session when localStorage is missing but cookies are present.
 */
export const initializeAuth = () => {
  return async (dispatch) => {
    try {
      // Backend now checks cookies automatically
      const response = await usersService.getMe()
      if (response && response.user) {
        // We might not have the token explicitly since it's in a cookie, 
        // but the app state expects it. We can store a placeholder or actual token if returned.
        const userData = {
          user: response.user,
          token: response.token || 'via-cookie'
        }
        window.localStorage.setItem('WiseAcademy-user', JSON.stringify(userData))
        dispatch({ type: SET_USER, user: userData })
        subscribeUser()
      }
    } catch (error) {
      // Not logged in or invalid cookie - silient fail as it's just an init check
      console.log('Auth check (cookie-based) failed: User not logged in.')
    }
  }
}

export default authReducer
